import React from "react";
import Table from "./Table/index";

export default function Users() {
  return (
    <div>
      <Table />
    </div>
  );
}
